import type { ReactNode } from "react";
import { Icon } from "../ui/Icon";

/**
 * Consistent card header: title (optionally a button that opens full-screen),
 * secondary meta text, and right-aligned actions.
 */
export function WidgetHeader({ title, meta, onTitle, actions }: { title: ReactNode; meta?: ReactNode; onTitle?: () => void; actions?: ReactNode }) {
  return (
    <header className="w-head">
      {onTitle ? (
        <button className="w-title" onClick={onTitle}>
          <span>{title}</span>
          <span className="w-chev" aria-hidden="true">
            <Icon name="chevronRight" size="0.9rem" />
          </span>
        </button>
      ) : (
        <h3 className="w-title">{title}</h3>
      )}
      {meta && <span className="w-meta">{meta}</span>}
      {actions && <div className="w-actions">{actions}</div>}
    </header>
  );
}
